module.exports = __webpack_public_path__ + "static/img/taxform_grey_180.9fcae49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/taxform_grey_180.png
// module id = 76
// module chunks = 2